var widget_default = {
  "card": "yIfZh",
  "link": "_2RmM6",
  "container": "wHoC7",
  "image": "v6mQH",
  "right": "aRMQH",
  "cardLayout": "Zk1bP",
  "content": "_5LWX1",
  "title": "_6quQG",
  "subtitle": "VCvEl",
  "button": "twugS",
  "button_disabled": "_19E5s",
  "buttonText": "c7FkT",
  "slimLayout": "rhj9h",
  "contentText": "T3keX"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
